import { atom } from 'recoil';
import { TAX_RULE } from './const/Const';
import { TFolderPicture, TPicture } from './types/cloudStorage/CloudFileList';
import { TTenant } from './types/common';
import { TLedger, TLedgerPictur } from './types/Ledger';
import { TExtInfo } from './types/ExtInfoBox';
import { TWorkingBudget } from './types/WorkingBudgetList';
import {
  TypeLayer,
  TypeRow,
  TypeVendorInfo,
  TypeWorkingBudgetInfo
} from './types/WorkingBudgetPage';
import { TGanttData, TGanttResource } from './types/process';
import { TUnbilledAlert } from './components/topicPath/type/Type';

export const isLoggedIn = atom({
  key: 'isLoggedIn',
  default: ''
});

export const mainBlueColor = atom({
  key: 'mainBlueColor',
  default: '#0099CC'
});

export const btnColor = atom({
  key: 'btnColor',
  default: '#52555F'
});

export const dashBoardData = atom({
  key: 'dashBoardData',
  default: 'data can be displayed here...'
});

export const constructData = atom({
  key: 'constructData',
  default: null
});

export const employeeMasterData = atom({
  key: 'employeeMasterData',
  default: null
});

export const estimatesData = atom({
  key: 'estimatesData',
  default: null
});

export const workingBudgetsData = atom<TWorkingBudget[] | undefined>({
  key: 'workingBudgetsData',
  default: []
});

export const workingBudgetData = atom<TypeLayer | undefined>({
  key: 'workingBudgetData',
  default: undefined
});

export const additionalCostData = atom<TypeRow[]>({
  key: 'additionalCostData',
  default: []
});

export const saveTimeStateData = atom({
  key: 'saveTimeStateData',
  default: ''
});

export const btnDisabledFlg = atom<boolean>({
  key: 'btnDisabledFlg',
  default: true
});

export const workingBudgetVendor = atom<TypeVendorInfo[] | undefined>({
  key: 'workingBudgetVendor',
  default: []
});

export const workingBudgetInfo = atom<TypeWorkingBudgetInfo | undefined>({
  key: 'workingBudgetInfo',
  default: undefined
});

export const inputPriceState = atom({
  key: 'inputPriceState',
  default: 0
});

export const inputAdditionalCostState = atom({
  key: 'inputAdditionalCostState',
  default: 0
});

export const inputAdditionalCostVenderState = atom({
  key: 'inputAdditionalCostVenderState ',
  default: 0
});

export const invoicesData = atom({
  key: 'invoicesData',
  default: null
});

export const paymentMethodsData = atom({
  key: 'paymentMethodsData',
  default: null
});

export const contractsData = atom({
  key: 'contractsData',
  default: null
});

export const merchandiseData = atom({
  key: 'merchandiseData',
  default: null
});

export const merchandiseItemStatus = atom({
  key: 'merchandiseItemStatus',
  default: null
});

export const outsourceData = atom({
  key: 'outsourceData',
  default: null
});

export const siteContactData = atom({
  key: 'siteContactData',
  default: null
});

export const estimateMasterData = atom({
  key: 'estimateMasterData',
  default: null
});

export const unitMasterData = atom({
  key: 'unitMasterData',
  default: null
});

export const constructTypeData = atom({
  key: 'constructTypeData',
  default: null
});

export const assignedUsersRecoilData = atom({
  key: 'assignedUsersRecoilData',
  default: null
});
export const assignedTypesRecoilData = atom({
  key: 'assignedTypesRecoilData',
  default: null
});

export const customerData = atom({
  key: 'customerData',
  default: null
});

export const customerRankRecoilData = atom({
  key: 'customerRankRecoilData',
  default: null
});

export const vendorTypeLargeRecoilData = atom({
  key: 'vendorTypeLargeRecoilData',
  default: null
});

export const vendorTypeSmallRecoilData = atom({
  key: 'vendorTypeSmallRecoilData',
  default: null
});

export const vendorRankRecoilData = atom({
  key: 'vendorRankRecoilData',
  default: null
});

export const vendorData = atom({
  key: 'vendorData',
  default: null
});

export const employeeGroupRecoilData = atom({
  key: 'employeeGroupRecoilData',
  default: null
});

export const userPasswordRecoilData = atom({
  key: 'userPasswordRecoilData',
  default: null
});

export const contractsTypeRecoilData = atom({
  key: 'contractsTypeRecoilData',
  default: null
});

export const selectedContractType = atom({
  key: 'selectedContractType',
  default: 1
});

export const furiganaRegex = atom({
  key: 'furiganaRegex',
  default: /^[\wあ-んぁ-ぉゃ-ょー\s]+$/
});

export const invalidPhoneNumberRegex = atom({
  key: 'invalidPhoneNumberRegex',
  default: /[a-zA-Z`!@$%^&()_=[\]{};':"\\|,.<>/?~]/
});

export const invalidFaxNumberRegex = atom({
  key: 'invalidFaxNumberRegex',
  default: /[a-zA-Z`!@$%^&()_=[\]{};':"\\|,.<>/?~]/
});

export const userRole = atom({
  key: 'userRole',
  default: undefined
});

export const isUserId = atom({
  key: 'isUserId',
  default: 0
});

export const isSortValue = atom({
  key: 'isSortValue',
  default: ['target_sales', 'actual_sales']
});

export const userIdState = atom({
  key: 'userIdState',
  default: 0
});

export const userNameState = atom({
  key: 'userNameState',
  default: ''
});

export const tenantNameState = atom({
  key: 'tenantNameState',
  default: ''
});

export const tenantTaxRuleState = atom({
  key: 'tenantTaxRuleState',
  default: TAX_RULE.FLOOR
});

export const constructionSortValue = atom({
  key: 'constructionSortValue',
  default: ''
});
export const constructionSortColumn = atom({
  key: 'constructionSortColumn',
  default: ''
});

export const userPlanId = atom({
  key: 'userPlanId',
  default: undefined
});

export const userMenuId = atom({
  key: 'userMenuId',
  default: undefined
});

export const progressFlgState = atom({
  key: 'progressFlgState',
  default: false
});

export const progressCountFlgState = atom({
  key: 'progressCountFlgState',
  default: false
});

export const progressCountState = atom({
  key: 'progressCountState',
  default: 0
});

export const resMessage = atom({
  key: 'resMessage',
  default: ''
});

export const openSuccessFlg = atom({
  key: 'openSuccessFlg',
  default: false
});

export const openErrorFlg = atom({
  key: 'openErrorFlg',
  default: false
});

export const userSiteManagePlanId = atom({
  key: 'userSiteManagePlanId',
  default: undefined
});

export const versionState = atom({
  key: 'version',
  default: ''
});

export const selectedPicturesState = atom<TPicture[]>({
  key: 'selectedPicturesState',
  default: []
});

export const folderListState = atom<TFolderPicture[]>({
  key: 'folderListState',
  default: []
});

export const addPicturesState = atom<TLedgerPictur[]>({
  key: 'addPicturesState',
  default: []
});

export const ledgerListState = atom<TLedger[]>({
  key: 'ledgerListState',
  default: []
});

export const ledgerdefaultValuesState = atom<TLedger>({
  key: 'ledgerdefaultValuesState',
  default: {
    construct_id: 0,
    title: '',
    pictures: []
  }
});

export const userTenant = atom<TTenant | undefined>({
  key: 'userTenant',
  default: undefined
});

export const accessibleMenuTreeId = atom({
  key: 'accessibleMenuTree',
  default: []
});

export const constructionExtInfoKey = atom<TExtInfo | undefined>({
  key: 'constructionExtInfoKey',
  default: undefined
});

export const customerExtInfoKey = atom<TExtInfo | undefined>({
  key: 'customerExtInfoKey',
  default: undefined
});

export const attendanceGanttData = atom<TGanttData>({
  key: 'attendanceGanttData',
  default: {
    resources: [],
    events: []
  }
});

export const attendanceAssignTotallOfDate = atom<any[]>({
  key: 'attendanceAssignTotallOfDate',
  default: []
});

export const siteProcessGanttChartResource = atom<TGanttResource[]>({
  key: 'siteProcessGanttChartResource',
  default: []
});

export const siteProcessDeleteGanttResourceIds = atom<string[]>({
  key: 'siteProcessDeleteGanttResourceIds',
  default: []
});

export const isEContractServiceEnabledState = atom({
  key: 'isEContractServiceEnabledState',
  default: false
});

export const gmoContractIdState = atom({
  key: 'gmoContractIdState',
  default: ''
});

export const daijinContractIdState = atom({
  key: 'daijinContractIdState',
  default: ''
});

export const unbilledAlerts = atom<TUnbilledAlert[]>({
  key: 'unbilledAlerts',
  default: []
});
